import { ModalComponent } from "../..";
import { SingleCooperativeMember } from "../../../../redux/features/cooperative/cooperative.type";
import { useInitiateMemberRemovalMutation } from "../../../../redux/features/membership/membership.api";
import { SuccessModal } from "../successModal";

export const RemoveMemberModal = ({
  isModalOpen,
  onModalClose,
  member,
  successCallback = () => {},
  modal,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  member: SingleCooperativeMember;
  successCallback: () => void;
  modal: string;
}) => {
  const [removeMember, { isLoading }] = useInitiateMemberRemovalMutation();

  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen && modal === "removeMemberModal"}
        onModalClose={() => {
          onModalClose();
        }}
        title="Remove member"
        subTitle={
          <p>
            You are about to initiate a{" "}
            <span className="font-bold">removal request</span> for{" "}
            <span className="text-pry-green-200">
              {member?.User?.FirstName} {member?.User?.LastName}
            </span>
            . This request requires approvals to be completed.
          </p>
        }
        childrenClassName=""
        modalClassName="!max-h-[330px]"
        hasButtons
        proceedButtonText="Initiate"
        onProceedClick={async () => {
          const resp = await removeMember({
            coop: member.Cooperative.id,
            id: member.id,
          });

          if (resp.data?.success) {
            successCallback();
          }
        }}
        proceedButtonVariant="danger"
        hasCancelButton
        cancelButtonText="Cancel"
        cancelButtonVariant="secondary"
        onCancelClick={onModalClose}
        isLoading={isLoading}
        isProceedDisabled={isLoading}
      />

      <SuccessModal
        subText={
          <p className="font-medium">
            You have successfully requested to remove{" "}
            <span className="text-pry-green-200">
              {member?.User?.FirstName} {member?.User?.LastName}
            </span>
            . Once approved, {member?.User?.FirstName} {member?.User?.LastName}{" "}
            will no longer be a member of {member?.Cooperative?.CoopName} .
          </p>
        }
        isModalOpen={isModalOpen && modal === "removeMemberSuccessModal"}
        onModalClose={() => {
          onModalClose();
        }}
      />
    </>
  );
};
